import { Box, Divider } from "@mui/material";
import FormGenerator from "../../../../Utils/FormGenerator/FormGenerator";
import SpecialPermissonSchema from "../../../../Config/ImportJob/CreateNewJob/General/SpecialPermissionSchema";
import { SectionHeader } from "../../../../Components/Header/SectionsHeader";
import { LuX } from "@/Components/Icons/Icons";
import { useRef } from "react";
// import { useUser } from "@/Context/UserContext";


export default function SpecialPermission({ onClose }) {
  const formRef = useRef();
  // const { formData } = useUser(); // ✅ DIRECT FROM ZUSTAND
  const handleCloseAndSend = async () => {
    console.log("✅ [SpecialPermission] Close clicked");

    const data = await formRef.current?.submit?.();
    console.log("✅ [SpecialPermission] Form submit data:", data);

    if (!data) {
      console.warn("⚠️ No data returned from FormGenerator");
      onClose([]); // ✅ send empty
      return;
    }

    const selectedKeys = Object.entries(data)
      .filter(([_, value]) => value === true)
      .map(([key]) => key);

    const rows = SpecialPermissonSchema?.row1?.[0]?.rows;

    const selectedLabels = [];

    for (const rowKey in rows) {
      const row = rows[rowKey];
      row.forEach((item) => {
        if (selectedKeys.includes(item.name)) {
          selectedLabels.push(item.checkboxLabel);
        }
      });
    }

    onClose(selectedLabels); // ✅ ONLY FOR THIS COMPONENT
  };
//   const rawPermissions =
//   formData?.general?.importerGeneralSpecialPermission || [];

// const normalizedPermissions = Array.isArray(rawPermissions)
//   ? rawPermissions
//   : typeof rawPermissions === "string"
//   ? rawPermissions.split(",").map((s) => s.trim())
//   : [];
//   const defaultCheckedValues = {};

//   const rows = SpecialPermissonSchema?.row1?.[0]?.rows;
  
//   for (const rowKey in rows) {
//     rows[rowKey].forEach((item) => {
//       if (
//         item.checkboxLabel &&
//         normalizedPermissions.includes(item.checkboxLabel)
//       ) {
//         defaultCheckedValues[item.name] = true;
//       }
//     });
//   }
  
  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "space-between",textAlign: "center", alignItems: "center",pr:2 }}>
        <SectionHeader title={"Special Permission"} />
        <LuX
          size={20}
          style={{ cursor: "pointer" }}
          onClick={handleCloseAndSend}   // ✅ ONLY HERE DATA SEND
        />
      </Box>

      <Divider />

      <Box sx={{ p: 2 }}>
        <FormGenerator schema={SpecialPermissonSchema}
         ref={formRef}
          //  defaultValues={defaultCheckedValues}

          />
      </Box>
    </Box>
  );
}

